/* eslint-disable max-len */

export const LINK_EXISTING_MEDSPA_ADMIN_TEXT = `If this is checked, you can select to link this provider to an existing Medspa Admin or have this provider be created as a Medspa Admin with a operating provider.`;
export const GRANT_ADMIN_ACCESS_TEXT =
  'Grant this person admin user access to My MedSpa / The Practice Management Dashboard.';
